<div class="evaluation-matrix overflow-x-auto">
  <table class="w-full border-separate border-spacing-y-2">
    <thead>
      <tr>
        <th class="p-3 text-left w-1/3 text-gray-200 font-semibold text-sm">
          {{ 'project.steps.rfd.evaluation.scenario' | transloco }}
        </th>
        @for (subcriteria of data().subcriteria; track subcriteria) {
          <th class="p-3 text-center font-semibold text-gray-200 text-sm">
            {{ subcriteria.translations | directusTranslation: currentLang() : '' : 'name' }}
          </th>
        }
        <th class="p-3 w-12"></th>
      </tr>
    </thead>
    <tbody>
      @for (item of data().agendaItems; track item) {
        <tr class="matrix-row">
          <td class="p-3 font-semibold text-gray-100 text-sm">
            {{ item.translations | directusTranslation: currentLang() : '' : 'topic' }}
          </td>
          @for (subcriteria of data().subcriteria; track subcriteria) {
            <td class="p-3 text-center">
              <div class="flex flex-col items-center gap-1">
                <app-rating-input
                  [value]="getRating(item.id, subcriteria.id)"
                  [readOnly]="readOnly()"
                  (valueChange)="onRate(item.id, subcriteria.id, $event)"
                ></app-rating-input>
              </div>
            </td>
          }
          <td class="p-3 text-center">
            <button
              pButton
              icon="pi pi-comment"
              class="p-button-text p-button-rounded p-button-sm"
              [ngClass]="{
                'text-red-500!': hasComment(item.id),
                'text-white!': !hasComment(item.id),
              }"
              (click)="openComment(item.id)"
              pTooltip="Comments"
            >
              <span class="sr-only">{{
                'project.steps.rfd.evaluation.comment.title' | transloco
              }}</span>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
